export enum SectionThemeDefaultColumnKeys {
  IndividualTerpenes = 'IndividualTerpenes',
  SecondaryCannabinoids = 'SecondaryCannabinoids',
  TagGroups = 'TagGroups'
}
